import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 30 30"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M7.813 2.5A2.816 2.816 0 0 0 5 5.313v19.375A2.816 2.816 0 0 0 7.813 27.5h14.375A2.816 2.816 0 0 0 25 24.688V12.5h-7.187A2.816 2.816 0 0 1 15 9.688V2.5zm9.062.55v6.638c0 .516.42.937.938.937h6.638zm-4.703 11.327a.95.95 0 0 1 .467.114l6.25 3.438a.938.938 0 0 1 0 1.643l-6.25 3.437a.94.94 0 0 1-.93-.016.94.94 0 0 1-.459-.805v-6.875c0-.33.176-.64.46-.809a.94.94 0 0 1 .462-.127" }, null, -1)
  ]))]))
}
export default { render: render }